module.exports = __webpack_public_path__ + "static/media/closeIcon.f5400e22.svg";